import React from "react";
import "./Loader.css";

const Loader = ({z_index = 2000,title_loader="Cargando"}) => {
  return (
    <div className="lds-ring" style={{zIndex:z_index}}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <p className="text-loader">{title_loader}</p>
    </div>
  );
};

export default Loader;